<template>
  <div>
    <v-card-text>
      Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eligendi amet doloribus rem eum!
      Itaque, temporibus est? Dignissimos natus illo consequatur quo provident sapiente porro quos
      odio, perspiciatis eaque nemo vero?
    </v-card-text>
    <v-container class="pt-0">
      <v-row>
        <v-col>
          <v-select
            :items="appointmentEnvironments"
            hide-details
            item-text="label"
            item-value="value"
            label="Where are you taking your appointment?"
            outlined
            required
            v-model="environment"
          ></v-select>
        </v-col>
        <v-col>
          <v-select
            :disabled="!environment"
            :items="appointmentTypes"
            hide-details
            item-text="label"
            item-value="value"
            label="What kind of appointment it is?"
            outlined
            required
            v-model="type"
          ></v-select>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'AppointmentType',
  components: {},
  data: () => ({
    environment: null,
    type: null,
    appointmentEnvironments: [
      {
        label: 'In Clinic',
        value: 'clinic',
      },
      {
        label: 'Virtual',
        value: 'virtual',
      },
    ],
    appointmentTypes: [
      {
        label: 'First Visit',
        value: 'first',
      },
      {
        label: 'Follow-Up',
        value: 'follow',
      },
    ],
  }),
  mounted() {
    this.environment = this.appointment.environment;
    this.type = this.appointment.type;
    this.$store.commit('updateAppointment', { title: 'Schedule your appointment' });
  },
  computed: {
    appointment() {
      return this.$store.state.appointment;
    },
  },
  watch: {
    environment(value) {
      this.$store.commit('updateAppointment', { environment: value });
    },
    type(value) {
      this.$store.commit('updateAppointment', { type: value, next: true });
    },
  },
};
</script>
